import ApiService from "@/services/api.service";
import getters from "@/store/global";

const state = {
    puzzles: [],
    puzzle: {},
    count: "",
    next: "",
    puzzleUpdated: "",
    bought: {},
    errors: {},
};

getters["fetchPuzzles"] = function (state) {
    return state.puzzles;
};
getters["fetchPuzzlesNext"] = function (state) {
    return state.next;
};
getters["fetchPuzzlesCount"] = function (state) {
    return state.count;
};
getters["fetchBought"] = function (state) {
    return state.bought;
};
getters["fetchPuzzleUpdated"] = function (state) {
    return state.puzzleUpdated;
};
getters["fetchPuzzle"] = function (state) {
    return state.puzzle;
};

const actions = {
    get(context, payload) {
        let url = "puzzles/?";
        let count = 0;
        for (let i in payload) {
            url += i + "=" + payload[i];
            if (count < Object.keys(payload).length - 1) {
                url += "&";
            }
            count++;
        }
        return ApiService.get(url)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_PUZZLES", response.data.results);
                context.commit("SET_COUNT", response.data.count);
                context.commit("SET_NEXT", response.data);
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    getNext(context) {
        return ApiService.get(context.getters.fetchNext)
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("ADD_PUZZLES", response.data.results);
                context.commit("SET_NEXT", response.data);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    getByPuzzleId(context, payload) {
        context.commit("GET_BY_PUZZLE_ID", payload);
    },
    getByPhotoId(context, payload) {
        return ApiService.get("puzzles/get_by_photo/" + payload + "/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_PUZZLE", response.data);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    buy(context, payload) {
        return ApiService.get("photos/" + payload + "/buy/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("SET_BOUGHT", response.data);
            })
            .catch((response) => {
                context.commit("SET_ERROR", response.data);
                throw new Error("Something goes wrong");
            });
    },
    saveProgress(context, payload) {
        return ApiService.put(
            "puzzles/" + payload.id + "/progress/",
            payload.data
        )
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("UPDATE_PROGRESS", [payload.id, payload.data]);
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
    setPuzzleUpdated(context, payload) {
        context.commit("UPDATE_PUZZLE", payload);
    },
    remove(context, payload) {
        return ApiService.delete("puzzles/" + payload + "/remove/")
            .then((response) => {
                context.commit("SET_ERROR", {});
                context.commit("REMOVE_PUZZLE", payload);
            })
            .catch(() => {
                throw new Error("Something goes wrong");
            });
    },
};

const mutations = {
    SET_PUZZLES(state, puzzles) {
        state.puzzles = puzzles;
        state.errors = {};
    },
    ADD_PUZZLES(state, puzzles) {
        state.puzzles = state.puzzles.concat(puzzles);
        state.errors = {};
    },
    REMOVE_PUZZLE(state, id) {
        for (let i in state.puzzles) {
            if (state.puzzles[i].id == id) {
                state.puzzles.splice(i, 1);
            }
        }
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
                data.url + "&" + data.page_param + "=" + (data.page + 1);
        } else {
            state.next = "";
        }
        state.errors = {};
    },
    GET_BY_PUZZLE_ID(state, id) {
        if (state.puzzles) {
            state.puzzle = state.puzzles.find((puzzle) => puzzle.id === id);
        } else {
            state.puzzle = {};
        }
    },
    SET_PUZZLE(state, puzzle) {
        state.puzzle = puzzle;
        state.errors = {};
    },
    SET_BOUGHT(state, bought) {
        state.bought = bought;
        state.errors = {};
    },
    UPDATE_PROGRESS(state, [id, data]) {
        for (let i in state.puzzles) {
            if (state.puzzles[i].id == id) {
                state.puzzles[i].progress = data.progress;
                state.puzzles[i].completed = data.completed;
                state.puzzleUpdated = id;
            }
        }
    },
    UPDATE_PUZZLE(state, id) {
        state.puzzleUpdated = id;
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
